import { type User } from '@/types';

/** The roles a company is normally assigned to; they head every employee picker. */
export const PRIORITY_ROLES = ['Sales Manager', 'Project Manager'];

/**
 * /api/users/assignable selects `uuid` and eager-loads the Spatie relation, while
 * users serialized from a page prop carry the appended `id` and the flat `role`
 * accessor. Either shape may turn up, so both helpers below read both.
 */
export type AssignableUser = Partial<User> & { uuid?: string; roles?: Array<{ name?: string }> };

export function roleNameOf(user: AssignableUser): string | null {
    if (Array.isArray(user.roles) && user.roles.length > 0) {
        return user.roles[0]?.name ?? null;
    }

    return (user.role as string | undefined) ?? null;
}

export function assignableUserId(user: AssignableUser): string {
    return String(user.uuid ?? user.id ?? '');
}
